exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".application-definition-conditional-editor .ant-tabs .ant-tabs-nav {\n  margin: 0;\n}\n.application-definition-conditional-editor .ant-tabs .ant-tabs-nav .application-setup-tab-header {\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n}\n.application-definition-conditional-editor .ant-tabs .ant-tabs-nav .application-setup-tab-header::after {\n  content: '';\n  width: 1px;\n  height: 18px;\n  margin-left: 32px;\n  background: #d9d9d9;\n}\n.application-definition-conditional-editor .ant-tabs .ant-tabs-tabpane {\n  max-height: calc(100vh - 170px);\n  overflow: auto;\n}\n", ""]);

// exports
